import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { clear } = useCart();
  const attempts = useRef(0);
  const clearedRef = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;

    const poll = async () => {
      if (attempts.current >= 8) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (cancelled) return;
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          if (!clearedRef.current) { clear(); clearedRef.current = true; }
          return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (!cancelled) setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="checkout-success-page">
      {status === "checking" && (
        <>
          <Loader2 className="animate-spin mx-auto text-terracotta mb-6" size={48} />
          <h1 className="font-serif-display text-3xl mb-3">Vérification du paiement...</h1>
          <p className="text-[#6B655C]">Merci de patienter quelques instants.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="w-20 h-20 mx-auto rounded-full bg-patchwork flex items-center justify-center mb-6">
            <Check size={36} className="text-white" strokeWidth={2.5} />
          </div>
          <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Merci ♡</p>
          <h1 className="font-serif-display text-4xl mb-4">Paiement confirmé</h1>
          <p className="text-[#6B655C] mb-8">Votre commande a bien été reçue. Nous préparons votre pièce avec soin.</p>
          <Link to="/shop" className="btn-primary" data-testid="continue-shopping-btn">Continuer les achats</Link>
        </>
      )}
      {(status === "expired" || status === "error" || status === "timeout") && (
        <>
          <h1 className="font-serif-display text-3xl mb-4">Une erreur est survenue</h1>
          <p className="text-[#6B655C] mb-6">Le paiement n'a pas pu être finalisé.</p>
          <Link to="/cart" className="btn-primary">Retour au panier</Link>
        </>
      )}
    </div>
  );
}
